export const DEFAULT_BASE_URL = "https://cloud-api.refuel.ai";
export const DEFAULT_MAX_RETRIES = 5;
export const DEFAULT_INITIAL_RETRY_TIMEOUT = 2_500;
export const DEFAULT_RETRY_STATUS_CODES = [202, 429, 504];
